<template>
<div class="w3-modal d-block">
    <div class="w3-modal-content w3-animate-zoom card border mt-3" :class="night ? 'bg-dark-gray text-white-50' : ''">
        <header class="card-header" :class="night ? 'w3-dark-gray' : ''">
            <button @click.prevent="cancel" class="btn btn-danger btn-sm px-2 float-end">
                <i class="fas fa-times"></i>
            </button>
            <div class="d-xl-flex d-lg-flex d-md-flex d-none align-items-center w3-large">
                <i class="fas fa-pen-square fa-2x text-warning me-2"></i>
                <span class="mx-auto">Editando información de usuario</span>
            </div>
            <div class="d-xl-none d-lg-none d-md-none d-flex align-items-center w3-medium">
                <i class="fas fa-pen-square fa-2x text-warning me-2"></i>
                <span class="mx-auto">Editando información de usuario</span>
            </div>
        </header>
        <div class="card-body">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-12 mb-3">
                    <div class="mb-3">
                        <div class="input-group">
                            <span class="input-group-text w3-light-gray">Nombre(s):</span>
                            <input type="text" class="form-control form-control-sm" v-model="userData.name" maxlength="100" :class="userData.name ? 'is-valid': 'is-invalid'" />
                            <div class="invalid-feedback ms-2">Este campo es obligatorio!!</div>
                        </div>
                        <div class="float-end me-2">{{ userData.name.length }}/100</div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-12 mb-3">
                    <div class="mb-3">
                        <div class="input-group">
                            <span class="input-group-text w3-light-gray">Usuario:</span>
                            <input type="text" class="form-control form-control-sm" v-model="userData.user" maxlength="100" :class="userData.user ? 'is-valid': 'is-invalid'" />
                            <div class="invalid-feedback ms-2">Este campo es obligatorio!!</div>
                        </div>
                        <small class="float-end me-2">{{ userData.user.length }}/100</small>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-12 mb-3">
                    <div class="input-group">
                        <span class="input-group-text w3-light-gray">Rol:</span>
                        <select class="form-select form-select-sm is-valid" v-model="userData.roleId">
                            <option v-for="(opt, index) in roles" :key="index" :value="opt.id">{{ opt.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <h5 class="text-center">Selecciona la jerarquia de organización</h5>
                    <org-treeData class="pt-2" v-for="(item, index) in organizacionesTree" :key="index" :$node="item" :$elemSelect="selectOrg" :$putElem="putOrg" :$night="night"></org-treeData>
                </div>
                <div class="col-xl-6 col-lg-6 offset-xl-3 offset-lg-3 col-10 offset-1 mb-3">
                    <button class="btn btn-info btn-sm btn-rounded btn-block" @click.prevent="addInfo">
                        <i class="fas fa-info-circle fa-lg me-2"></i>
                        <span>Agregar más información</span>
                    </button>
                </div>
            </div>
            <inputform-extradata-users v-for="(info, index) in jsonData" :key="index" v-bind:$info="info" v-bind:$delItem="delInfo" v-bind:$index="index" v-bind:$id="info.id" v-bind:$createRegister="createJsonData"></inputform-extradata-users>
        </div>
        <footer class="card-footer" :class="night ? 'w3-dark-gray' : ''">
            <div v-if="load">
                <button class="btn btn-secondary btn-rounded btn-block" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Cargando...
                </button>
            </div>
            <div v-else class="row">
                <div class="col">
                    <button class="btn btn-danger btn-sm btn-rounded btn-block" @click.prevent="cancel">
                        <i class="fas fa-ban"></i>
                        <span>Cancelar</span>
                    </button>
                </div>
                <div class="col">
                    <button class="btn btn-success btn-sm btn-rounded btn-block" :disabled="isDisabledSave" @click.prevent="updateUser">
                        <i class="fas fa-save"></i>
                        <span>Guardar</span>
                    </button>
                </div>
            </div>
        </footer>
    </div>
</div>
</template>

<script>
import $axios from 'axios'
import $swal from 'sweetalert2'
export default {
    props: {
        _user: Object,
        _reload: Function,
        _rolReload: Function,
    },
    created() {
        this.nightMode();
        this.getRoles();
        this.jsonData = JSON.parse(this._user.extradata);
        this.getorganizaciones();
        this.userData = {
            name: this._user.name,
            user: this._user.user,
            roleId: this._user.role,
            extraData: {},
            orgId: this._user.orgId,
        }
        this.selectOrg.id = this._user.orgId;
    },
    data() {
        return {
            night: null,
            load: false,
            roles: {},
            jsonData: [],
            userData: {},
            organizacionesTree: {},
            selectOrg: {},
        }
    },
    mounted() {
        window.Echo.channel('channel-darkmode').listen('DarkModeChangeEvent', (e) => {
            this.nightMode();
        });
    },
    methods: {
        nightMode() {
            if (localStorage.nightMode == 'true') {
                this.night = true;
            }
            if (localStorage.nightMode == 'false') {
                this.night = false;
            }
        },
        updateUser() {
            this.load = true;
            this.userData.extraData = JSON.stringify(this.jsonData);
            $axios.put(this.$masterRoute + '/api/users/' + this._user.id, this.userData, {
                headers: {
                    Authorization: 'Bearer ' + JSON.parse(sessionStorage.authToken)
                }
            }).then(response => {
                if (response.data.status) {
                    $swal.fire(
                        'Acción exitosa!',
                        response.data.menssage,
                        'success'
                    );
                    this._reload();
                    this._rolReload();
                    this.cancel();
                } else {
                    $swal.fire({
                        icon: 'error',
                        title: 'Error!!',
                        text: response.data.menssage,
                    });
                }
                this.load = false;
            }).catch(error => {
                if (error.response.status === 401) {
                    $swal.fire({
                        icon: 'error',
                        title: 'Sesión expirada',
                        text: 'No tiene autorizado continuar en el sistema, inicie sesion!!',
                    }).then((result) => {
                        this.$router.push({
                            name: 'login'
                        });
                    });
                } else {
                    $swal.fire({
                        icon: 'error',
                        title: 'Error Inesperado!!',
                        text: 'El sistema obtuvo un error inesperado, por favor comunicate con soporte para solucionarlo',
                    });
                }
                console.log(error.response);
                this.load = false
            });
        },
        getRoles() {
            $axios.get(this.$masterRoute + '/api/getRoles/users', {
                headers: {
                    Authorization: 'Bearer ' + JSON.parse(sessionStorage.authToken)
                }
            }).then(response => {
                this.roles = response.data;
            }).catch(error => {
                if (error.response.status === 401) {
                    $swal.fire({
                        icon: 'error',
                        title: 'Sesión expirada',
                        text: 'No tiene autorizado continuar en el sistema, inicie sesion!!',
                    }).then((result) => {
                        this.$router.push({
                            name: 'login'
                        });
                    });
                } else {
                    $swal.fire({
                        icon: 'error',
                        title: 'Error Inesperado!!',
                        text: 'El sistema obtuvo un error inesperado, por favor comunicate con soporte para solucionarlo',
                    });
                }
                console.log(error.response);
                this.load = false
            })
        },
        addInfo() {
            this.jsonData.push({
                titulo: '',
                texto: '',
            });
        },
        delInfo(item) {
            this.jsonData.splice(item, 1);
        },
        createJsonData(index, titulo, texto) {
            this.jsonData[index].titulo = titulo;
            this.jsonData[index].texto = texto;
        },
        saveIsEnable() {
            let isTrue = false;
            this.jsonData.forEach(item => {
                Object.values(item).forEach(val => {
                    if (!val) {
                        isTrue = true;
                    }
                });
            });
            return isTrue;
        },
        cancel() {
            this.$router.go(-1);
        },
        getorganizaciones() {
            $axios.get(this.$masterRoute + '/api/organizaciones', {
                headers: {
                    Authorization: 'Bearer ' + JSON.parse(sessionStorage.authToken)
                }
            }).then(response => {
                this.organizacionesTree = this.generateTree(response.data);
            }).catch(error => {
                if (error.response.status === 401) {
                    $swal.fire({
                        icon: 'error',
                        title: 'Sesión expirada',
                        text: 'No tiene autorizado continuar en el sistema, inicie sesion!!',
                    }).then((result) => {
                        this.$router.push({
                            name: 'login'
                        });
                    });
                } else {
                    $swal.fire({
                        icon: 'error',
                        title: 'Error Inesperado!!',
                        text: 'El sistema obtuvo un error inesperado, por favor comunicate con soporte para solucionarlo',
                    });
                }
                console.log(error.response);
                this.load = false;
            });
        },
        putOrg(elem) {
            this.selectOrg = elem;
            this.userData.orgId = elem.id;
        },
        generateTree(data) {
            let map = {},
                node,
                roots = [],
                i;
            for (i = 0; i < data.length; i++) {
                map[data[i].id] = i;
                data[i].children = [];
            }
            for (i = 0; i < data.length; i++) {
                node = data[i];
                if (node.parentId) {
                    if (node.parentId) {
                        data[map[node.parentId]].children.push(node);
                    }
                } else {
                    roots.push(node);
                }
            }
            this.load = false;
            return roots;
        },
    },
    computed: {
        isDisabledSave() {
            if (!this.userData.name || !this.userData.user) {
                return true;
            }
            if (this.jsonData.length) {
                return this.saveIsEnable();
            }
            return false;
        },
    }
}
</script>
